import React from 'react';
import { useSession } from 'src/contexts/SessionContext';
import EventsTable from 'src/shared/pageComponents/Events/EventsTable';

const EventsPage: React.FC = () => {
  const { user } = useSession();

  return (
    <>
      <EventsTable user={user} />
    </>
  );
};

export default EventsPage;
